import React, { Fragment, useState, useEffect  } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import estilos from './InfoBar.module.css'

const InfoBar = (props) => {
    
    const dispatch = useDispatch()
    const nombreSolicitud = props.nombreSolicitud
    
    const [stickyClass, setStickyClass] = useState('');

    useEffect(() => {
      window.addEventListener('scroll', stickNavbar);
      return () => window.removeEventListener('scroll', stickNavbar);
    }, []);
  
    const stickNavbar = () => {
      if (window !== undefined) {
        let windowHeight = window.scrollY;
        windowHeight > 150 ? setStickyClass(estilos.sticky_nav) : setStickyClass('');
      }
    };

    return (
        <Fragment>
            <div className='container'>
           <nav className={`navbar-nav ${stickyClass}`}>
                    <div className={`row mb-2 mt-2`}>
                        <div className="col-md-12" role="group" aria-label="Paginas">
                        <h3 className='text-center'>{nombreSolicitud}</h3>
                        </div>
                    </div>
            </nav>
            </div>
        </Fragment>
    )
};

export default withRouter(InfoBar)
